import { Box, BoxProps, ThemeProvider, useTheme } from '@mui/material';
import React, { useMemo } from 'react';

import type { Theme } from '../../themes/themes';
import { getStyles } from './ThemedBox.styles';

interface Props {
  createLightTheme: () => Theme;
  createDarkTheme: () => Theme;

  children: React.ReactNode;

  id?: BoxProps['id'];
}

export const ThemedBox: React.FC<Props> = ({ createLightTheme, createDarkTheme, children, ...rest }: Props) => {
  const currentTheme = useTheme<Theme>();

  const theme = useMemo(() => {
    if (currentTheme.palette.mode == 'dark') {
      return createDarkTheme();
    }
    return createLightTheme();
  }, [currentTheme.palette.mode, createLightTheme, createDarkTheme]);

  const styles = getStyles(theme);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={styles.container} {...rest}>
        {children}
      </Box>
    </ThemeProvider>
  );
};
